<template>
    <Spinner v-if="companyAppStore.isLoading || topPageStore.isLoading" />
    <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--mypage">

        <Header/>

        <section class="l-content-area">
          <div class="l-content">

            <!-- MYPAGE -->
            <section class="p-bloc p-bloc--mypage">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">

                  <section class="p-mypage">

                    <!-- Mypage Menu -->
                    <NavbarMyPage/>

                    <!-- Side Menu -->
                    <SideMenu/>

                    <!-- Mypage Content -->
                    <div class="p-mypage__content">
                      <div class="mypage-content">

                        <!-- merchant -->
                        <div class="p-mypage__usage p-mypage__usage--merchant mypage-bloc">
                          <div class="mypage-bloc__head">
                            <h2>{{ $t('LABEL_USED_MERCHANT') }}</h2>
                          </div>
                          <div class="mypage-bloc__content">

                            <!-- search -->
                            <search class="usage__search usage__search--merchant">
                                <div>
                                    <div class="search__input">
                                        <input id="input-site-name" v-model="companyAppStore.siteName" type="search" name="search-usage" :placeholder="$t('LABEL_KEYWORD')">
                                    </div>
                                    <div class="search__ui">
                                    <div class="search__select">
                                        <select id="select-merchant-status" name="state" v-model="companyAppStore.status">
                                            <option :value="null" :selected="null">{{ $t("LABEL_USAGE_STATUS") }}</option>
                                            <option v-for="(value, index) in STATUS_CLASS" :key="index"
                                            :value="index">{{ $t(index) }}</option>
                                        </select>
                                    </div>
                                    <div class="search__btn">
                                        <button id="btn-clear-merchant" class="c-btn__clear" type="reset" v-on:click="clear">{{ $t('LABEL_BUTTON_CLEAR_SEARCH') }}</button>
                                        <button id="btn-search-merchant" class="c-btn__search" @click="searchMerchants(1)">{{ $t('LABEL_BUTTON_SEARCH') }}</button>
                                    </div>
                                    </div>
                                </div>
                            </search>

                            <!-- merchant list -->
                            <div class="usage__list usage__list--merchant">
                              <div class="usage__empty" v-if="companyAppStore.registeredApps.length < 1">
                                <h2>{{ $t('TEXT_RECORDS_NOT_FOUND') }}</h2>
                                <p>{{ $t('TEXT_MERCHANT_NOT_FOUND') }}</p>
                              </div>

                              <CompanyApplications v-if="companyAppStore.registeredApps.length > 0" v-bind:company-apps="companyAppStore.registeredApps" @refresh-merchants="clear"/>
                            </div>

                            <!-- PAGING: If there are less than 10 items, hide this area. -->
                            <div class="usage__paging">
                                <Paginator v-model="companyAppStore.page" :length="companyAppStore.totalPages"
                                @update:modelValue="searchMerchants" v-if="companyAppStore.registeredApps.length > 0" />
                            </div>

                          </div>
                        </div>

                      </div><!-- .mypage-content -->
                    </div>

                  </section>

                </div>
              </div>
            </section>


          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->
      <Footer/>
    </div>
</template>
<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
import Paginator from "@/components/Paginator.vue";
import CompanyApplications from "@/components/CompanyApplications.vue";
import { onBeforeMount } from "vue";
import Spinner from "@/components/Spinner.vue";
import { useTopPageStore } from "@/stores/topPageStore";
import { useCompanyAppStore } from "@/stores/companyAppStore";
import { STATUS_CLASS } from "@/data/constants";

const topPageStore = useTopPageStore();
const companyAppStore = useCompanyAppStore();

onBeforeMount(async () => {
    await topPageStore.getTopPageData();
    await companyAppStore.getRegisteredMerchants(1);
});

async function searchMerchants(page) {
    companyAppStore.page = page;
    await companyAppStore.getRegisteredMerchants(page);
}

async function clear() {
    companyAppStore.siteName = '';
    companyAppStore.status = null;

    companyAppStore.page = 1;
    await companyAppStore.getRegisteredMerchants(1);
}
</script>